"use client";

import { BENEFITS_SURVEY_SUBMIT } from "@shared/constants";

import DebtPayoffCalculatorForm from "@client/components/debt-payoff-calculator";
import DebtCalculatorCTACard from "@client/components/debt-payoff-calculator/components/cta-card";
import Formik from "@client/components/debt-payoff-calculator/components/formik";

import Main from "@ui/js/components/main";

import type SurveyType from "@packages/types/survey";
import {
  defaultFieldValues,
  type defaultFieldValuesType,
} from "@packages/types/yup/debt-payoff-calculator";

interface DebtPayoffCalculatorPageParams {
  hasCTA?: boolean;
}

export default function DebtPayoffCalculatorPage({
  hasCTA,
}: DebtPayoffCalculatorPageParams) {
  const submitMethod = BENEFITS_SURVEY_SUBMIT as SurveyType.SubmitMethod;
  const redirectPath = hasCTA
    ? "/debt-payoff-calculator/has-cta/results"
    : "/debt-payoff-calculator/results";
  const initialValues: defaultFieldValuesType = defaultFieldValues;
  return (
    <Main pageName="debt-payoff-calculator">
      <div className="container">
        <div className="col-span-12 lg:col-span-6 lg:col-start-4 mt-8">
          <h1 className="font-semibold text-2xl text-center">
            Debt Payoff Calculator
          </h1>
          <div className="text-center mt-2">
            Add your unsecured debts to discover your payoff date and how you
            can accelerate your time to debt freedom.{" "}
          </div>
          <Formik
            initialValues={initialValues}
            redirectPath={redirectPath}
            submitMethod={submitMethod}
          >
            <DebtPayoffCalculatorForm />
          </Formik>
        </div>
      </div>
      {hasCTA && <DebtCalculatorCTACard hasCTA page="debt-entry" />}
    </Main>
  );
}
